import UIHoverCardController from "controllers/ui/hover-card_controller";

export default class UITooltipController extends UIHoverCardController {}
